export default {
    state: {
        show: false,
        // 1
        authType: 1,
        // 手机号码
        mobile: '',
        idNum: '',
        userName: '',
        // 成功后回调的方法
        backFun: null,
        // 关闭后回调的方法
        closeFun: null,
        dx: {
            code: '',
            count: 0,
            timer: null,
            loading: false,
            subLoading: false,
        },
        face: {
            bizNo: '',
            success: true,
            time: 0,
            loading: false
        },
        loading: false,
    },
    mutations: {
        /**
         * 关闭模态框
         * @param state
         */
        closeModal (state) {
            state.show = false
        },
        
        /**
         * 打开模态框
         * @param state
         * @param backFun
         * @param mobile
         * @param idNum
         * @param userName
         * @param closeFun
         */
        openFaceSmsModal (state, { backFun, mobile, idNum, userName, closeFun }) {
            // 保存回调
            state.backFun = backFun
            // 保存回调
            state.closeFun = closeFun || null
            
            // 插件参数
            state.mobile = mobile
            state.idNum = idNum
            state.userName = userName
            
            // 默认刷脸
            state.authType = 1
            
            // 打开验证
            state.show = true
        },
        /**
         * 完成验证进行回调
         * @param state
         */
        completeBackFun (state,) {
            // state,
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/faceSms.js